import PropTypes from 'prop-types';
import React from 'react';

export const LangsContext = React.createContext();

export const useLangs = () => React.useContext(LangsContext);

export const LangsContextProvider = ({ allLangs, children, language = 'en' }) => {
    return <LangsContext.Provider value={allLangs[language]}>{children}</LangsContext.Provider>;
};

LangsContextProvider.propTypes = {
    allLangs: PropTypes.object.isRequired,
    children: PropTypes.any,
    language: PropTypes.string,
};
